import { CustomTour, CustomTourFormData } from '../types';
import { appConfig } from '../config/appConfig';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:4000/api';

// Helper function to get admin token
const getAdminToken = (): string => {
  return btoa(`${appConfig.admin.username}:${appConfig.admin.password}`);
};

// Get all custom tours
export const fetchAllCustomTours = async (): Promise<CustomTour[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/custom-tours`, {
      headers: {
        'Authorization': `Bearer ${getAdminToken()}`,
        'Accept': 'application/json',
      },
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    return data.items || [];
  } catch (error) {
    console.error('Error fetching custom tours:', error);
    throw new Error('Failed to fetch custom tours');
  }
};

// Create a new custom tour
export const createCustomTour = async (customTourData: CustomTourFormData): Promise<CustomTour> => {
  try {
    const response = await fetch(`${API_BASE_URL}/custom-tours`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${getAdminToken()}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(customTourData),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error creating custom tour:', error);
    throw error;
  }
};

// Update a custom tour
export const updateCustomTour = async (id: string, customTourData: Partial<CustomTourFormData>): Promise<CustomTour> => {
  try {
    const response = await fetch(`${API_BASE_URL}/custom-tours/${id}`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${getAdminToken()}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(customTourData),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error updating custom tour:', error);
    throw error;
  }
};

// Delete a custom tour
export const deleteCustomTour = async (id: string): Promise<void> => {
  try {
    const response = await fetch(`${API_BASE_URL}/custom-tours/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${getAdminToken()}`,
        'Accept': 'application/json',
      },
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
    }
  } catch (error) {
    console.error('Error deleting custom tour:', error);
    throw error;
  }
};
